import React from 'react';
import Chart from 'react-apexcharts';

const MyChart = () => {
  const chartOptions = {
    series: [{
      name: 'Sales',
      data: [30, 40, 35, 50, 49, 60, 70, 91, 125]
    }],
    options: {
      chart: {
        height: 350,
        type: 'line',
        zoom: {
          enabled: false
        }
      },
      dataLabels: {
        enabled: false
      },
      stroke: {
        curve: 'smooth'
      },
      xaxis: {
        categories: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep']
      }
    }
  };

  return (
    <div className="w-full">
      <Chart
        options={chartOptions.options}
        series={chartOptions.series}
        type="line"
        height={350}
      />
    </div>
  );
};

export default MyChart;
